<template>
  <van-row class="page-show">
    <!-- 背景图片 -->
    <img class="background-show" src="@/assets/background.png" alt="">
    <!-- 表单内容 -->
    <van-col span="20" class="form-body">
      <div class="code-show">邀请码：{{queryParams.parentInviteCode}}</div>
      <van-cell-group>
        <van-field
          @input="queryParamsAgentName"
          v-model="queryParams.agentName" 
          placeholder="公司名称(企业填单位,个人填姓名)" 
          :left-icon="require('@/assets/icon_phone.png')"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          @input="queryParamsPhone"
          v-model="queryParams.agentAccount" 
          placeholder="请输入手机号码" 
          :left-icon="require('@/assets/icon_phone.png')"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          @input="queryParamsPsd" 
          v-model="queryParams.password" 
          placeholder="请输入密码" 
          :left-icon="require('@/assets/icon_password.png')"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          @input="queryParamsCode" 
          v-model="queryParams.smsCode" 
          placeholder="请输入验证码"
          :left-icon="require('@/assets/icon_code.png')"
        >
          <template #button>
            <span @click="getCode">{{codeText}}</span>
          </template>
        </van-field>
      </van-cell-group>
      <van-checkbox v-model="checked" shape="square" icon-size="12px" label-disabled>
        <p :class="checked == true ? 'checkbox-show color-true' : 'checkbox-show'">
          我已查看并同意
          <span @click="goPage('/richText?type=1')">《用户注册协议》</span>
          和
          <span @click="goPage('/richText?type=2')">《用户隐私》</span>
        </p>
      </van-checkbox>
      <van-button class="button-show" @click="submit">代理注册</van-button>
      <p class="bottom-show" @click="goPage('/download')">已注册用户可点击<span>下载APP</span></p>
    </van-col>
  </van-row>
</template>

<script>
  import { getSmsCode, agentRegisterCode, agentRegisterUser } from '@/api/index'
  import { Toast, Dialog } from 'vant';
  export default {
    name: 'Home',
	  data() {
	    return {
        queryParams: {
          agentName: '',
          agentAccount: '',
          password: '',
          smsCode: '',
          parentInviteCode: ''
        },
        code: this.GetQueryString('id'),
        codeText: '点击获取',
        checked: false
	    };
	  },
    created(){
      this.agentRegisterCode();
    },
	  methods: {
      // 页面跳转
      goPage(data){
        this.$router.replace(data, () => {
          window.location.reload()
        })
      },
      // 获取表单内容
      queryParamsAgentName(event){
        this.queryParams.agentName = event;
      },
      queryParamsPhone(event){
        this.queryParams.agentAccount = event;
      },
      queryParamsPsd(event){
        this.queryParams.password = event;
      },
      queryParamsCode(event){
        this.queryParams.smsCode = event;
      },
      // 获取参数
      GetQueryString(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
      },
      // 倒计时
      getCode(){
        if(!this.queryParams.agentAccount){
          Toast('手机号码不能为空');
          return
        }
        if(this.codeText == '点击获取'){
          var that = this;
          that.codeText=60;
          that.getSmsCode();
          var timeClock=setInterval(function(){
            that.codeText--;
            if (that.codeText == 0) {
                clearInterval(timeClock);
                that.codeText = '点击获取'
            } 
          },1000)
        }
      },
      // 获取验证码
      getSmsCode(){
        getSmsCode({ 
          agentAccount: this.queryParams.agentAccount, 
          smsType: 'register' 
        })
        .then(res => {
          Toast(res.msg)
        })
      },
      // ID 换取 邀请码
      agentRegisterCode(){
        agentRegisterCode({ id: this.code }).then(res => {
          this.queryParams.parentInviteCode = res.data.parentInviteCode;
        })
      },
      // 提交内容
      submit(){
        if(!this.queryParams.agentAccount){
          Toast('手机号码不能为空');
          return
        }
        if(!this.queryParams.password){
          Toast('密码不能为空');
          return
        }
        if(!this.queryParams.smsCode){
          Toast('验证码不能为空');
          return
        }
        if(this.checked == false){
          Toast('请查看协议并同意');
          return
        }
        agentRegisterUser(this.queryParams).then(res => {
          Dialog.alert({
            message: '注册成功，请前往下载！',
          }).then(() => {
            this.goPage('/download');
          });
        })
      }
    },
	};
</script>

<style scoped lang="scss">
  .page-show{
    height: 100vh;

    .background-show{
      width: 100%;
      height: 99%;
    }

    .form-body{
      width: 90vw;
      height: 85vh;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 10px;
      position: absolute;
      top: 10vh;
      left: 5vw;
      display: flex;
      align-items: center;
      flex-direction: column;

      .code-show{
        font-size: 16px;
        color: #14BBE0;
        opacity: 1;
        margin-top: 5vh;
        margin-bottom: 5vh;
      }

      .van-cell-group{
        width: 80%;
        border: 1px solid #DDDDDD;
        opacity: 1;
        border-radius: 12px;
        margin-bottom: 2.4vh;
        .van-cell{
          background-color: rgba(255,255,255,0.2);
        }
      }

      .van-checkbox{
        width: 80vw;
        margin-left: 5vw;
        font-size: 12px;
        .checkbox-show{
          margin: 0;
          span{
            color: red;
          }
        }
        .color-true{
          color: #14BBE0;
        }
      }
      
      .button-show{
        color: #FFFFFF;
        opacity: 1;
        background: #14BBE0;
        border-radius: 8px;
        font-size: 14px;
        width: 75vw;
        margin-top: 6vh;
      }

      .bottom-show{
        opacity: 1;
        font-size: 12px;
        span{
          color: #14BBE0;
        }
      }
    }
  }
</style>